import React from "react";

export const PhoneInterviewTypeBadge = () => (
        <svg
            width="52"
            height="20"
            viewBox="0 0 52 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="52" height="20" rx="3" fill="#E9E9F0" />
            <path
                d="M7.47903 14H8.69803V10.619H9.98603C11.734 10.619 12.6885 9.791 12.6885 8.273C12.6885 6.778 11.7455 5.9845 9.98603 5.9845H7.47903V14ZM8.69803 9.4805V7.123H9.85953C10.9635 7.123 11.4465 7.4795 11.4465 8.296C11.4465 9.101 10.952 9.4805 9.85953 9.4805H8.69803ZM14.2735 14H15.504V10.458H19.23V14H20.4605V5.9845H19.23V9.3195H15.504V5.9845H14.2735V14ZM25.9163 14.1495C28.1588 14.1495 29.6883 12.4935 29.6883 9.998C29.6883 7.491 28.1703 5.835 25.9163 5.835C23.6623 5.835 22.1328 7.491 22.1328 9.998C22.1328 12.4935 23.6623 14.1495 25.9163 14.1495ZM25.9163 12.9765C24.3638 12.9765 23.3633 11.838 23.3633 9.998C23.3633 8.1465 24.3638 7.008 25.9163 7.008C27.4688 7.008 28.4578 8.158 28.4578 9.998C28.4578 11.8265 27.4688 12.9765 25.9163 12.9765ZM36.1965 5.9845V11.8495L32.6315 5.9845H31.355V14H32.5855V8.1005L36.139 14H37.427V5.9845H36.1965ZM39.6543 14H44.9558V12.8615H40.8848V10.458H44.6223V9.3195H40.8848V7.123H44.9558V5.9845H39.6543V14Z"
                fill="black"
                fill-opacity="0.54"
            />
        </svg>
    );
